import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { KeyboardEvent, FocusEvent } from 'react';
import { InputType } from './../EditComponent';

interface CurrencyEditComponentProps {
  label?: string;
  localVal: InputType;
  handleSave: (
    value: InputType,
    e?:
      | KeyboardEvent<HTMLDivElement>
      | KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
      | FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => void;
  change?: (v: string | number | null) => void;
  setLocalVal: (v: InputType) => void;
}

export const CurrencyEditComponent = ({
  label,
  localVal,
  handleSave,
  change,
  setLocalVal
}: CurrencyEditComponentProps) => {
  return (
    <TextField
      variant="outlined"
      type="number"
      onChange={(e) => {
        const inputValue = e.target.value;
        if (inputValue === '') {
          setLocalVal(null);
          change && change(null);
        } else {
          const parsed = parseFloat(inputValue);
          const formatted = Number(parsed.toFixed(2));
          setLocalVal(formatted);
          change && change(parsed);
        }
      }}
      value={localVal || ''}
      inputRef={(input) => input && input.focus()}
      size="small"
      onBlur={(e) => handleSave(undefined, e)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSave(undefined, e);
        }
      }}
      slotProps={{
        input: {
          startAdornment: <InputAdornment position="start">$</InputAdornment>
        },
        htmlInput: {
          'data-testid': `${(label || '').replace(' ', '-').toLowerCase()}-currency-field`
        }
      }}
    />
  );
};
